import { Container } from "@mui/material";
import { styled } from "@mui/material/styles";
import { LoginForm } from "src/sections/auth/login";
import Message from "./Message";
import NoAccountSection from "./NoAccountSection";
import useResponsive from "../../../../../hooks/useResponsive";

const ContentStyle = styled("div")(({ theme }) => ({
  maxWidth: 480,
  margin: "auto",
  display: "flex",
  flexDirection: "column",
  justifyContent: "flex-start",
  padding: theme.spacing(4, 0),
  [theme.breakpoints.up("md")]: {
    minHeight: "100vh",
    justifyContent: "center",
    padding: theme.spacing(12, 0),
  },
}));

const MainSection = () => {
  const mdDown = useResponsive('down', 'md');

  return (
    <Container maxWidth="sm">
      <ContentStyle>
        <Message mdDown={mdDown}/>

        <LoginForm />

        <NoAccountSection />
      </ContentStyle>
    </Container>
  );
};

export default MainSection;
